import { render, staticRenderFns } from "./DocPrivacy.vue?vue&type=template&id=033e5799&scoped=true"
import script from "./DocPrivacy.vue?vue&type=script&lang=js"
export * from "./DocPrivacy.vue?vue&type=script&lang=js"
import style0 from "./DocPrivacy.vue?vue&type=style&index=0&id=033e5799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e5799",
  null
  
)

export default component.exports